package com.tovtalk.ui.theme

import androidx.compose.ui.text.font.FontFamily

// Open Sans is loaded in index.html + main.css. Canvas uses SansSerif (browser may match to Open Sans when loaded).
actual val TovTalkFontFamily: FontFamily = FontFamily.SansSerif
